export function numberToString(num: number | undefined | null, maxDec: number = 2): string {
    if (num != undefined) {
        return num.toLocaleString(undefined, { minimumFractionDigits: 2 , maximumFractionDigits: maxDec, useGrouping:true});
    }
    return "";
}

function esFormat(v: number): string {
    const parts = Math.abs(v).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const formatted = parts.join(",");
    return v < 0 ? "-" + formatted : formatted;
}

/** Monetary amount with Spanish locale (1.234,56). Returns "" for null/undefined. */
export function fmtAmt(v: number | null | undefined): string {
    return v == null ? "" : esFormat(v);
}

/** Same but returns "—" for null/undefined. */
export function fmtAmtDash(v: number | null | undefined): string {
    return v == null ? "—" : esFormat(v);
}

/** Non-zero monetary amount. Returns "" for null/undefined/zero. */
export function fmtAmtNz(v: number | null | undefined): string {
    return v == null || v === 0 ? "" : esFormat(v);
}

/** Monetary amount with EUR symbol and Spanish locale (1.234,56 €). Returns "—" for null/undefined. */
export function fmtEur(v: number | null | undefined): string {
    return v == null ? "—" : esFormat(v) + " €";
}

export function fmtAccountCode(code?: string | null): string {
    return code ?? "";
}
